import { extend } from 'vee-validate';

extend('amount', {
    validate(value, { amount }: any) {
        return amount > 0;
    },
    params: ['amount']
});
